interface GetLocalizedFormattedPriceStringConfig {
    locale: string;
    currency: string;
    value: number;
}

export const getLocalizedFormattedPriceString = ({
    locale,
    currency,
    value,
}: GetLocalizedFormattedPriceStringConfig) => {
    //TODO: Pull this locale formatting out to a stadalone
    //util. Potentially in a separate lib.
    //https://eventbrite.atlassian.net/browse/EB-217341
    const formattedLocale = locale.replace('_', '-');

    //try to use narrow symbol but some versions of Safari
    //do not support it so fallback to symbol.
    const numberFormatConfig = {
        style: 'currency',
        currencyDisplay: 'narrowSymbol',
        currency,
    };

    try {
        return new Intl.NumberFormat(
            formattedLocale,
            numberFormatConfig,
        ).format(value / 100);
    } catch (error: unknown) {
        if (error instanceof RangeError || error instanceof TypeError) {
            return new Intl.NumberFormat(formattedLocale, {
                ...numberFormatConfig,
                currencyDisplay: 'symbol',
            }).format(value / 100);
        }

        throw error;
    }
};
